import { Box } from "@mui/system";
import { Editor } from "@tinymce/tinymce-react";
import { useFormContext } from "react-hook-form";

const key = "5ehfqm10flqk74ik44yyz6pnn8q6r719ham1w4enj9tiko11";

export default function HtmlEditor({ editorRef, onInitCb }: any) {
  const { setValue } = useFormContext();
  return (
    <Box
      sx={{
        "& .tox-statusbar__right-container": {
          display: "none!important",
        },
      }}
    >
      <Editor
        apiKey={key}
        onInit={(_evt, editor) => {
          editorRef.current = editor;
          onInitCb?.(editor);
        }}
        onEditorChange={(content) => {
          setValue("emailBody", content, { shouldDirty: true });
        }}
        init={{
          selector: "textarea",
          invalid_elements: "script,style,form,iframe,video,canvas",
          plugins: [
            "autolink",
            "link",
            "lists",
            "image",
            "table",
            "visualblocks",
          ],
          formats: {
            h1: { block: "h1" },
            h2: { block: "h2" },
            h3: { block: "h3" },
            h4: { block: "h4" },
            h5: { block: "h5" },
            h6: { block: "h6" },
          },
          block_formats:
            "Paragraph=p;Header 1=h1;Header 2=h2;Header 3=h3;Header 4=h4;Header 5=h5;Header 6=h6",
          toolbar:
            "undo redo | blocks | bold italic underline strikethrough | link image table | align lineheight | numlist bullist indent outdent | removeformat",
          menubar: false,
          automatic_uploads: true,

          images_upload_handler: (blobInfo) => {
            return new Promise(async (resolve, reject) => {
              try {
                // Get base64 string directly from TinyMCE API
                const base64 = blobInfo.base64();
                const mime = blobInfo.blob().type;
                const dataUrl = `data:${mime};base64,${base64}`;

                // Keep base64 in your form state
                setValue("base64", dataUrl, { shouldDirty: true });

                // ✅ TinyMCE will insert this as <img src="data:...">
                resolve(dataUrl);
              } catch (error: any) {
                reject("Image upload failed: " + error.message);
              }
            });
          },
        }}
      />
    </Box>
  );
}
